export default function Card({ children }) {
  return (
    <div className="bg-slate-200 rounded p-4 flex ">
      <div className="flex flex-col w-full ">{children}</div>
    </div>
  );
}
